import { OneLineText } from '@/components/OneLineText';
import { FileText } from 'lucide-react';
import { useMemo, useState } from 'react';
import { DocumentListDialog } from '@/components/DocumentListDialog';
import { VendorResponse } from '@/types/vendor.types';

const VendorDocumentContent = ({ vendorData }: { vendorData: VendorResponse | undefined }) => {
  const [openDocumentList, setOpenDocumentList] = useState<boolean>(false);
  const [activeDocumentIndex, setActiveDocumentIndex] = useState<number | undefined>(undefined);

  const documents = useMemo(() => {
    return (
      vendorData?.documents?.map((document) => ({
        media: document.media!,
        name: document?.name,
      })) ?? []
    );
  }, [vendorData?.documents]);

  return (
    <div className="flex flex-col pt-2 gap-2 justify-center items-center">
      {documents?.length ? (
        documents?.reverse().map((document, index) => (
          <div
            key={document.media.mediaId}
            className="flex w-full flex-row gap-4 cursor-pointer items-center bg-[#F5F5F5] rounded-lg pt-4 p-3"
            onClick={() => {
              setOpenDocumentList(true);
              setActiveDocumentIndex(index);
            }}
          >
            <div>
              <FileText className="w-5 h-5 text-primary" />
            </div>
            <OneLineText text={document.name} className="font-medium text-base text-primary" />
          </div>
        ))
      ) : (
        <span className=" text-sm text-placeholder font-[500]">No Documents Found</span>
      )}
      {openDocumentList && (
        <DocumentListDialog
          documents={documents.reverse()}
          onCloseClick={() => setOpenDocumentList(false)}
          activeIndex={activeDocumentIndex}
        />
      )}
    </div>
  );
};

export default VendorDocumentContent;
